import script from "./OutcomesView.vue?vue&type=script&setup=true&lang=js"
export * from "./OutcomesView.vue?vue&type=script&setup=true&lang=js"

import "./OutcomesView.vue?vue&type=style&index=0&id=ee59442e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee59442e"]])

export default __exports__